import React from 'react';

export default function ContactListEmptyState({ onRefresh }) {
  return (
    <div className="max-w-3xl mx-auto text-center bg-white/5 border border-white/10 rounded-3xl px-8 py-12 shadow-xl shadow-black/30">
      <h2 className="text-2xl font-semibold text-white mb-4">
        No contacts yet
      </h2>
      <p className="text-gray-300 mb-8">
        Scan a business card or upload one through the scanner to start
        building your TadReamk contacts library. Once processed, all
        extracted information appears here instantly.
      </p>
      <button
        type="button"
        onClick={onRefresh}
        className="inline-flex items-center justify-center px-6 py-3 rounded-full font-semibold text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 transition-colors shadow-lg shadow-purple-900/40"
      >
        Refresh contacts
      </button>
    </div>
  );
}


